import _ from 'lodash';

export default class UserAgreementTemplate{
	
	constructor(app){
		this.app = app;
	}

	async getScreens(){
		const newScreens =  _.cloneDeep(screens);
		this.app.experiment.center({elements: newScreens[0].elements, horizontal:true});
		newScreens[0].elements[1].x -= 70;
		newScreens[0].elements[2].x += 70;
		return newScreens;
	}
};

const screens = [{
	"id": "UserAcceptance",
	"elements": [
		{
			"type": "text",
			"id": "UserAcceptance",
			"x": 145,
			"y": 79,
			"width": 400,
			"height": 190,
			"text": "By clicking below, I agree to give the owner of this experiment access to any information stored in My Profile (email and password are not shared).\n\nI understand this information may be used by the researcher, and possibly published in results from the experiment.",
			"onClick": ""
		},
		{
			"type": "button",
			"id": "agree-to-terms",
			"x": 344,
			"y": 280,
			"width": 100,
			"height": 50,
			"text": "I Agree",
			"expected": "I Agree",
			"onClick": "{next}"
		},
		{
			"type": "button",
			"id": "agree-to-terms",
			"x": 344,
			"y": 280,
			"width": 100,
			"height": 50,
			"text": "I Decline",
			"expected": "I Agree",
			"onClick": "{finish}"
		}

	]
}];


// WEBPACK FOOTER //
// ./src/models/templates/UserAgreementTemplate.js